import EformBaseService from "../../../../services/EformBaseService";

export default class SbfiProjektfinanzierungsgesuchService extends EformBaseService {

  constructor() {
    super('wbf/sbfi/projektfinanzierungsgesuch')
  }
}
